import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import InventorySvg from '../../../assets/icons/nav/inventory.svg?raw';

export const InventoryIcon = (props) => <CustomSVG svg={InventorySvg} preserveColors {...props} />;
